import DateFnsUtils from '@date-io/date-fns';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import styles from 'styles/modules/newsAlert/InputPicker.module.scss';
import Calendar from 'components/Svg/Calendar';

const DatePicker = ({ date, setDate, setDateValid }) => {
    return (
        <div className={styles.wrapper}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    ampm={false}
                    value={date}
                    onChange={(value) => setDate(value)}
                    className={styles.picker}
                    format={'dd/MM/yyyy'}
                    keyboardIcon={<Calendar />}
                    onError={(error) => setDateValid(!error)}
                    disablePast
                />
            </MuiPickersUtilsProvider>
        </div>
    );
};

export default DatePicker;
